import makeStyles from '@material-ui/core/styles/makeStyles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme => ({
  tableContainer: {
    backgroundColor: '#fff',
    borderRadius: 15,
    boxShadow: '2px 3px 10px #7777771A',
  },
  table: {
    minWidth: 650,
  },
  tableEmpty: {
    minHeight: 308,
  },
  tableCellHead: {
    fontSize: 18,
    fontWeight: 600,
    padding: 20,
    borderBottom: '2px solid #f5f5f5',
    textAlign: ({ direction }: LayoutDirection) => direction === 'rtl' ? `start` : `unset`
  },
  tableSortIcon: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 10px',
  },
  tableCell: {
    fontSize: 16,
    fontWeight: 400,
    padding: '22px 20px',
    height: 92,
    borderBottom: '1px solid #f5f5f5',
    textAlign: ({ direction }: LayoutDirection) => direction === 'rtl' ? `start` : `unset`
  },
  tableActions: {
    width: 88,
  },
  tableItemDefaultStyle: {
    fontSize: 16,
    fontWeight: 300,
    color: theme.palette.grey['400'],
  },
  menu: {
    boxShadow: 'none',
    border: `1px solid ${theme.palette.grey[800]}`,
    borderRadius: 10,
  },
  menuItemText: {
    color: theme.palette.grey[100],
  },
  inactiveSort: {
    fill: theme.palette.grey[400],
  },
}));
